class ComoFunciona {
  constructor() {
    document.querySelector('.close-modal').addEventListener('click', () => {
      document.querySelector('.modal-regulamento').classList.remove('open')
    })

    document.querySelector('.open-modal').addEventListener('click', () => {
      document.querySelector('.modal-regulamento').classList.add('open')
    })
  }
}

export default ComoFunciona
